import backendHttpClient from '@services/_httpClient/backend.http-client';

import type { CreateNotePayload } from './dtos/create.dto';
import type { UpdateNoteDto, UpdateNotePayload } from './dtos/update.dto';
import type { NoteRepository } from './repository';
import type { CreateNoteOutput, CreateNoteResponse } from './types/create.type';
import type {
  GetNoteByIdOutput,
  GetNoteByIdResponse,
} from './types/getById.type';
import type { UpdateNoteOutput, UpdateNoteResponse } from './types/update.type';

class NoteService implements NoteRepository {
  public async create(payload: CreateNotePayload): Promise<CreateNoteOutput> {
    const { data } = await backendHttpClient.post<
      CreateNoteResponse,
      CreateNotePayload
    >({
      body: payload,
      path: 'notes',
    });

    return { note: data.note };
  }

  public async getById(id: string): Promise<GetNoteByIdOutput> {
    const { data } = await backendHttpClient.get<GetNoteByIdResponse>({
      path: `notes/${id}`,
    });

    return { note: data.note };
  }

  public async update(payload: UpdateNotePayload): Promise<UpdateNoteOutput> {
    const { data } = await backendHttpClient.put<
      UpdateNoteResponse,
      UpdateNoteDto
    >({
      body: {
        content: payload.content,
        title: payload.title,
      },
      path: `notes/${payload.id}`,
    });

    return { note: data.note };
  }

  public async delete(id: string): Promise<void> {
    await backendHttpClient.delete<void>({
      path: `notes/${id}`,
    });
  }
}

export const noteService = new NoteService();
